import React from 'react';
import PropTypes from 'prop-types';
import { getAlertSource } from '../../../../../utility/alertDisplayUtils';

const cellStyle = {
  maxWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const SourceCell = ({ alert, channel }) => {
  const isRAMAX = alert.deviceType === 'RAMAX';
  const source = getAlertSource(alert, channel, isRAMAX, alert.componentName || '');
  return (
    <td className="align-middle" style={cellStyle} title={source}>
      {source || '—'}
    </td>
  );
};

SourceCell.propTypes = {
  alert: PropTypes.shape({
    channelKey: PropTypes.object,
    componentName: PropTypes.string,
    deviceType: PropTypes.string,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  channel: PropTypes.object.isRequired,
};

export default SourceCell;
